import React from "react";
import { Box } from "@gti-controls-v2/web-core";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/images/logo-masorden-blanco-small.svg"
import homePageStyles from "../../../common/styles/HomePage";
import { paths } from "../../../common/constants/Rutas";

const LogoHeader = () => {
    const styles = homePageStyles;
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(paths.HomePage);
    };

    return (
        <Box sx={styles.toolbar} >
            <Box sx={styles.drawerLogo}>
                <Box
                    component="img"
                    src={logo}
                    alt="login"
                    sx={styles.drawerImageIcon}
                    onClick={handleBack}
                />
            </Box>
        </Box>
    );
};

export default LogoHeader;